import HttpService from '@src/utility/httpService';
import { checkIsInternal } from '@src/utility/createStorage';
import { config } from '@uhg-abyss/web/tools/config';

const _httpService = new HttpService();
const CASE_SUBMISSION_DETAILS_ENDPOINT = '/prior-authorizations/case-submission-details/';
const SUBMISSION_DETAILS_ENDPOINT = '/prior-authorizations/submissiondetails/';

interface SubmissionDetailsData {
  PriorAuthAutoApprovedCount?: number | null;
  PriorAuthAutoApprovedPercent?: number | null;
  PriorAuthNotRequiredCount?: number | null;
  PriorAuthNotRequiredPercent?: number | null;
}

interface PriorAuthResponse {
  StatusCode?: number;
  Data?: Record<string, unknown>;
  [key: string]: unknown;
}

if (checkIsInternal()) {
  _httpService.setBaseURL(config('API_DOMAIN_INTERNAL') as string);
} else {
  _httpService.setBaseURL(config('API_DOMAIN_EXTERNAL') as string);
}

const mergeCaseSubmissionData = (
  caseSubmissionData: Record<string, unknown> | undefined,
  submissionDetailsData: SubmissionDetailsData | undefined
) => ({
  ...caseSubmissionData,
  PriorAuthAutoApprovedCount: submissionDetailsData?.PriorAuthAutoApprovedCount || 0,
  PriorAuthAutoApprovedPercent: submissionDetailsData?.PriorAuthAutoApprovedPercent || null,
  PriorAuthNotRequiredCount: submissionDetailsData?.PriorAuthNotRequiredCount || 0,
  PriorAuthNotRequiredPercent: submissionDetailsData?.PriorAuthNotRequiredPercent || null,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getPSMSPACaseSubmissionData = (payload: any) => {
  const fetchData = async () => {
    try {
      const [caseSubmissionResponse, submissionDetailsResponse] = (await Promise.all([
        _httpService.push(CASE_SUBMISSION_DETAILS_ENDPOINT, payload),
        _httpService.push(SUBMISSION_DETAILS_ENDPOINT, payload),
      ])) as [PriorAuthResponse | null, PriorAuthResponse | null];

      if (!caseSubmissionResponse) return null;

      return {
        ...caseSubmissionResponse,
        Data: mergeCaseSubmissionData(
          caseSubmissionResponse?.Data,
          submissionDetailsResponse?.StatusCode === 200
            ? (submissionDetailsResponse?.Data as SubmissionDetailsData)
            : undefined
        ),
      };
    } catch (error) {
      console.error('Error fetching PSMS PA case submission data:', error);
      return null;
    }
  };
  return fetchData();
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getPSMSPACaseSubmissionChannelData = (payload: any) => {
  const fetchData = async () => {
    try {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const response: any = await _httpService.push(
        '/prior-authorizations/case-submission-trend/?requestType=CHANNEL',
        payload
      );
      return response;
    } catch (error) {
      console.error('Error fetching PSMS PA case submission channel data:', error);
      return null;
    }
  };
  return fetchData();
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getPSMSPAApprovalDenialTrendData = (payload: any) => {
  const fetchData = async () => {
    try {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const response: any = await _httpService.push(
        '/prior-authorizations/approval-denial-trend/',
        payload
      );
      return response;
    } catch (error) {
      console.error('Error fetching PSMS PA approval denial trend data:', error);
      return null;
    }
  };
  return fetchData();
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getPSMSPATatTrendData = (payload: any) => {
  const fetchData = async () => {
    try {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const response: any = await _httpService.push('/prior-authorizations/tat-trend/', payload);
      return response;
    } catch (error) {
      console.error('Error fetching PSMS PA TAT trend data:', error);
      return null;
    }
  };
  return fetchData();
};
